import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import TextArea from 'modules/core/components/TextArea'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import type { Assessment } from 'modules/competencies/store/models/Assessment'

interface Props {
  assessment: Assessment
  onClose: () => void
  comment: string
  setComment: (value: string) => void
  canEdit: boolean
  isDraft: boolean
}

const CommentModal = ({ assessment, onClose, comment, setComment, canEdit, isDraft }: Props) => {
  const { running, performAction } = useAsyncAction(async () => {
    await assessment.save({ description: comment })
    onClose()
  })

  const closeAction = canEdit && isDraft ? i18n.t('common.cancel') : i18n.t('common.close')

  return (
    <Modal
      title={i18n.t('competencies_v2.assessments.comment.title', {
        competency_name: assessment.competency.attributes.name,
      })}
      onSubmit={performAction}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" disabled={running} onClick={onClose}>
            {closeAction}
          </Button>
          {canEdit && isDraft && (
            <Button disabled={running} submit>
              {i18n.t('competencies_v2.assessments.comment.save')}
            </Button>
          )}
        </>
      }
    >
      <TextArea
        placeholder={isDraft ? i18n.t('competencies_v2.assessments.comment.placeholder') : ''}
        value={comment && comment.length > 0 ? comment : assessment.attributes.description}
        onChange={(value) => setComment(value)}
        readonly={running || !canEdit || !isDraft}
      />
    </Modal>
  )
}

export default observer(CommentModal)
